import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxErrorPagesModule } from '@uzenith360/ngx-error-pages';
import { lazyLoad } from 'src/lazy-load';

const routes: Routes = [
  { path: 'error', loadComponent: () => lazyLoad(() => import('@uzenith360/ngx-error-pages')).then(mod => mod.PageErrorComponent) },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  { path: 'auth', loadChildren: () => lazyLoad(() => import('./auth/auth.module')).then(m => m.AuthModule) },
  { path: 'home', loadChildren: () => lazyLoad(() => import('./home/home.module')).then(m => m.HomeModule) },
  { path: '**', loadComponent: () => lazyLoad(() => import('@uzenith360/ngx-error-pages')).then(mod => mod.PageNotFoundComponent) }
];

@NgModule({
  imports: [
    NgxErrorPagesModule.forRoot({
      errorPage: {
        backText: 'home',
        backURL: '../',
        description: 'There was an error displaying this page',
        heading: '500 Page Error',
      },
      notFoundPage: {
        backText: 'home',
        backURL: '../',
        description: 'This link does not exist',
        heading: '404 Page Not Found',
      },
    }),
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
